import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Tenant from './tenant';
import Fleet from './fleet';
import Location from './location';
import Session from './session';
import Activity from './activity';
import Station from './station';
import Device from './device';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}
        <Route path="tenant/*" element={<Tenant />} />
        <Route path="fleet/*" element={<Fleet />} />
        <Route path="location/*" element={<Location />} />
        <Route path="session/*" element={<Session />} />
        <Route path="activity/*" element={<Activity />} />
        <Route path="station/*" element={<Station />} />
        <Route path="device/*" element={<Device />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
